import * as e from "react";
import { forwardRef as o } from "react";
import { c as a } from "./index.js-Cr0Rsuyz.mjs";
function c(r, t) {
  return /* @__PURE__ */ e.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t
  }, r), /* @__PURE__ */ e.createElement("path", {
    fill: "currentColor",
    d: "M11.25 20v-7.25H4a.75.75 0 0 1 0-1.5h7.25V4a.75.75 0 0 1 1.5 0v7.25H20a.75.75 0 0 1 0 1.5h-7.25V20a.75.75 0 0 1-1.5 0"
  }));
}
var f = a(/* @__PURE__ */ o(c));
export {
  f as I
};
